import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesArchiveBooks1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.96 6.1V0H13.72v1.52h-6.1v1.53H3.05v10.67H1.53v3.04H0V32h32V6.1ZM7.62 30.48H1.53v-9.15h6.09Zm0-10.67H4.58V4.57h3.04ZM9.15 3.05h4.57v1.52h-3.05v15.24H9.15Zm4.57 3.05v13.71H12.2V6.1Zm1.52 24.38H9.15v-9.15h6.09Zm15.24 0H16.77V19.81h-1.53V1.52h12.19V6.1h-4.57v1.52h7.62Z\"/><path fill=\"currentColor\" d=\"M25.91 21.33h1.52v1.53h-1.52Zm0-3.04h1.52v1.52h-1.52Zm-3.05 4.57h3.05v1.52h-3.05Zm-1.52-1.53h1.52v1.53h-1.52Zm0-3.04h1.52v1.52h-1.52Zm0-10.67h1.52v3.05h-1.52Zm-1.53 3.05h1.53v3.05h-1.53Zm-1.52 3.05h1.52v3.04h-1.52Zm0-10.67h1.52v1.52h-1.52Zm-1.52 13.71h1.52v3.05h-1.52Zm-6.1 7.62h3.05v3.05h-3.05Zm-7.62 0H6.1v3.05H3.05Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesArchiveBooks1
